
import React, { useEffect, useMemo, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Modal, ModalBody, Spinner, UncontrolledDropdown } from 'reactstrap';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, ReactDataTable, RSelect } from '../../../../components/Component';
import { WEBSITE_BASE_URL } from '../../../../config';
import ToastExample from '../../../../helpers/toast';
import Content from '../../../../layout/content/Content';
import Head from '../../../../layout/head/Head';
import { createCoupon, deleteCoupon, getAllCoupons, toggleCoupon, updateCoupon } from '../../../../redux/admin/promotion/action';
import { nonActiveFormSubmissionStatus, openFormLoading } from '../../../../redux/common/actions';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { getAllCities } from '../../../../redux/admin/cities/actions';
import { getAllItems } from '../../../../redux/admin/item/action';
import { getAllWarehouses } from '../../../../redux/admin/warehouse/action';
import noimage from '../../../../assets/images/noimage.png'

const Coupons = () => {
    const dispatch = useDispatch(); //defining dispatch

    //function to get data from backend
    useEffect(() => {
        dispatch(getAllCoupons());
        dispatch(getAllCities());
        dispatch(getAllItems());
        dispatch(getAllWarehouses());
    }, []);

    //to warehouse data from application state to a constant
    const getSelectors = (state) => ({
        coupons: state.promotion.coupons,
        warehouses: state.warehouse.warehouse,
        items: state.item.items,
        cities: state.cities.cities,
        form_loading: state.common.form_loading,
        form_submission_status: state.common.form_submission_status,

    });
    const { warehouses, coupons, items, cities, form_loading, form_submission_status, } = useSelector(getSelectors);
    const [editingCoupon, setEditingCoupon] = useState([]);   //edit category state
    const [editingCouponImage, setEditingCouponImage] = useState([]);   //edit image state
    const [deletingCoupon, setDeletingCoupon] = useState([]);   //delete category state
    const [formData, setFormData] = useState([]);   //form data state defined
    const [showToast, setShowToast] = useState(false);   //toast state
    const [data, setData] = useState([]);  //data state defined
    const [cityId, setCityId] = useState('All');  //data state defined
    const [image, setImage] = useState(null);  //data state defined
    const [image2, setImage2] = useState(null);  //data state defined
    const [couponType, setCouponType] = useState("SINGLE_WAREHOUSE");  //isMultiple state defined
    const [warehouseId, setWarehouseId] = useState();  // state defined
    const [warehouseIds, setWarehouseIds] = useState([]);  // state defined
    const [itemIds, setItemIds] = useState([]);  // state defined
    const [popular, setPopular] = useState(false);  // state defined
    //modal state
    const [modal, setModal] = useState({
        edit: false,
        add: false,
        delete: false,
    });

    //to open add modal
    const openAddModal = () => {
        setEditingCoupon([]);
        dispatch(nonActiveFormSubmissionStatus());
        setImage(null)
        setImage2(null)
        setCityId("All")
        setPopular(false)
        setWarehouseId(null)
        setWarehouseIds([]);
        setItemIds([]);
        setTimeout(() => {
            setModal({ add: true });
        }, 100);
        setCouponType("STORE")
    };

    //to open edit modal
    const openEditModal = (category) => {
        setModal({ edit: true });
        setEditingCoupon(category);
        setPopular(category.is_popular === 1 ? true : false)
        dispatch(nonActiveFormSubmissionStatus());
        setImage(null);
        setImage2(null);
        setCityId(category.city_id)
        setCouponType(category.coupon_type)
        if (category.coupon_type === "SINGLE_WAREHOUSE") {
            setWarehouseId(category?.warehouses[0]?.id ?? null)
        } else if (category.coupon_type === "MULTI_WAREHOUSE") {
            setWarehouseIds(category.warehouses.map((cw) => (cw.id)));
        } else if (category.coupon_type === "ITEM") {
            setItemIds(category.items.map((ci) => (ci.id)));
        }
    };

    //to open delete modal
    const openDeleteModal = (category) => {
        setModal({ delete: true });
        dispatch(nonActiveFormSubmissionStatus());
        setDeletingCoupon(category);
    };

    //store lists
    const listCities = cities?.map((city) => (
        { value: city.id, label: city.name }
    ));

    const AllWarehouse = warehouses?.filter(cp => (cityId == "All" ? cp : cp?.city_id == cityId)).map((warehouse) => (
        { value: warehouse.id, label: warehouse.name }
    ));
    const AllItems = items?.filter(cp => (cityId == "All" ? cp : cp?.warehouse?.city_id == cityId)).map((item) => (
        { value: item.id, label: item.name }
    ));
    const discount_type = [
        { value: 'FIXED', label: 'FIXED' },
        { value: 'PERCENTAGE', label: 'PERCENTAGE' }
    ];
    const coupon_types = [
        { value: 'SINGLE_WAREHOUSE', label: 'Single Warehouse' },
        { value: 'MULTI_WAREHOUSE', label: 'Multi Warehouse' },
        { value: 'ITEM', label: 'Item' }
    ];
    const user_types = [
        { value: 'ALL', label: 'Unlimited Times For All Users' },
        { value: 'ONCENEW', label: 'Once For New User For First Order' },
        { value: 'ONCE', label: 'Once Per User' },
        { value: 'CUSTOM', label: 'Define Custom Limit Per User' },
    ];

    //form validation with yup
    const categorySchema = yup.object({

        name: yup.string(),
        radius: yup.string(),
        latitude: yup.string(),
        longitude: yup.string(),
        type: yup.string(),
        discount_type: yup.string(),
        coupon_code: yup.string(),
        coupon_discount: yup.string(),
        max_discount: yup.string(),
        start_date: yup.string(),
        end_date: yup.string(),
        min_sub_total: yup.string(),
        max_count: yup.string(),
        sub_total_message: yup.string(),
        user_type: yup.string(),
        city_id: yup.string(),
        description: yup.string(),
    });



    //form values
    const defaultValues = useMemo(
        () => ({
            id: editingCoupon?.id || "",
            name: editingCoupon?.name || "",
            radius: editingCoupon?.radius || "",
            latitude: editingCoupon?.latitude || "",
            longitude: editingCoupon?.longitude || "",
            description: editingCoupon?.description || "",
            discount_type: editingCoupon?.discount_type || "",
            coupon_code: editingCoupon?.coupon_code || "",
            coupon_discount: editingCoupon?.coupon_discount || "",
            max_discount: editingCoupon?.max_discount || "",
            start_date: editingCoupon?.start_date || "",
            end_date: editingCoupon?.end_date || "",
            min_sub_total: editingCoupon?.min_sub_total || "",
            sub_total_message: editingCoupon?.sub_total_message || "",
            user_type: editingCoupon?.user_type || "",
            max_count: editingCoupon?.max_count || "",
            type: editingCoupon?.type || "",
            city_id: editingCoupon?.city_id || "",

        }),
        [editingCoupon]
    );

    //form methods
    const methods = useForm({
        resolver: yupResolver(categorySchema),
        defaultValues: defaultValues,
    });

    //useform methods
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control
    } = methods;

    //submit function
    const onFormSubmit = (submitData) => {
        dispatch(openFormLoading());
        console.log(submitData, 'submitdata');
        let warehouse_ids = JSON.stringify(warehouseIds);
        let item_ids = JSON.stringify(itemIds);
        const new_data = new FormData();
        new_data.append('id', editingCoupon?.id);
        new_data.append('name', submitData?.name);
        new_data.append('token', localStorage.getItem('accessToken'));
        if (image) {
            new_data.append('image', image);
        }
        if (image2) {
            new_data.append('image2', image2);
        }
        new_data.append('radius', submitData?.radius);
        new_data.append('latitude', submitData?.latitude);
        new_data.append('longitude', submitData?.longitude);
        new_data.append('description', submitData?.description);
        new_data.append('discount_type', submitData?.discount_type);
        new_data.append('coupon_code', submitData?.coupon_code);
        new_data.append('coupon_discount', submitData?.coupon_discount);
        new_data.append('max_discount', submitData?.max_discount);
        new_data.append('start_date', submitData?.start_date);
        new_data.append('end_date', submitData?.end_date);
        new_data.append('min_sub_total', submitData?.min_sub_total);
        new_data.append('sub_total_message', submitData?.sub_total_message);
        new_data.append('user_type', submitData?.user_type);
        new_data.append('coupon_type', couponType);
        new_data.append('max_count', submitData?.max_count);
        new_data.append('is_popular', popular);
        new_data.append('city_id', submitData?.city_id);
        if (couponType == 'SINGLE_WAREHOUSE') {
            new_data.append('warehouse_id', warehouseId);
        } else if (couponType == 'MULTI_WAREHOUSE') {
            new_data.append('warehouse_ids', warehouse_ids);
        } else if (couponType == 'ITEM') {
            new_data.append('item_ids', item_ids);
        }
        if (modal.edit) {
            setTimeout(() => {
                dispatch(updateCoupon(new_data));
            }, 50);
        } else if (modal.add) {
            dispatch(createCoupon(new_data));
        } else if (modal.delete) {
            dispatch(deleteCoupon(deletingCoupon?.id));
        }
        resetForm();
    };

    // to reset the form
    const resetForm = () => {
        setFormData({
            name: "",
            radius: "",
            latitude: "",
            longitude: "",
            description: "",
            discount_type: "",
            coupon_code: "",
            coupon_discount: "",
            max_discount: "",
            start_date: "",
            end_date: "",
            min_sub_total: "",
            sub_total_message: "",
            user_type: "",
            max_count: "",
            city_id: "",
        });
    };

    //to close modal
    const onFormCancel = () => {
        setModal({ edit: false, add: false, delete: false });
        document.getElementsByClassName("invalid").innerHTML = "";
        resetForm();
    };

    //category toggle
    const handleCategoryStatus = (e, id) => {
        dispatch(toggleCoupon(id));
        setTimeout(() => {
            dispatch(getAllCoupons());
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    //submit toast
    useEffect(() => {
        if (modal.add == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllCoupons());
                setData(coupons);
                setModal({ add: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }

        if (modal.edit == true && editingCoupon && form_loading == false && form_submission_status == true) {
            dispatch(getAllCoupons());
            setData(coupons);
            setModal({ edit: false });
            setShowToast(true);
            reset(defaultValues);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        } else {
            reset(defaultValues);
        }

        if (modal.delete == true && form_loading == false && form_submission_status == true) {
            setTimeout(() => {
                dispatch(getAllCoupons());
                setData(coupons);
                setModal({ delete: false });
                setShowToast(true);
            }, 500);
            setTimeout(() => {
                setShowToast(false);
            }, 3000);
        }
    }, [createCoupon, form_loading, modal, form_submission_status]);

    const getCouponType = (type) => {
        if (type === 'SINGLE_WAREHOUSE') {
            return "Single Warehouse";
        } else if (type === 'MULTI_WAREHOUSE') {
            return "Multi-Warehouse";
        } else if (type === 'ITEM') {
            return "Item";
        }
    }
    //headers of datatable
    const tableHeadings = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            compact: true,
            style: { paddingRight: "20px" },
            cell: (row) => {
                return (
                    <div className="user-card mt-2 mb-2" id={row.id}>
                        {row?.image ?
                            <img src={WEBSITE_BASE_URL + row.image} alt="item" style={{ width: '6rem', borderRadius: "5px" }} />
                            :
                            <div className='d-flex flex-column align-items-center ml-3'>
                                <img src={noimage} alt="item" style={{ height: '5vh', width: '5vh' }} />
                                <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                            </div>
                        }
                    </div>
                );
            },
        },
        {
            name: "Single Image",
            selector: (row) => row.image2,
            compact: true,
            style: { paddingRight: "20px" },
            cell: (row) => {
                return (
                    <div className="user-card mt-2 mb-2" id={row.id}>
                        {row?.image2 ?
                            <img src={WEBSITE_BASE_URL + row.image2} alt="item" style={{ width: '6rem', borderRadius: "5px" }} />
                            :
                            <div className='d-flex flex-column align-items-center ml-3'>
                                <img src={noimage} alt="item" style={{ height: '5vh', width: '5vh' }} />
                                <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                            </div>
                        }
                    </div>
                );
            },
        },
        {
            name: "Type",
            selector: (row) => row.coupon_type ? getCouponType(row.coupon_type) : 'No Coupon Type',
            sortable: true,
        },
        {
            name: "Coupon Code",
            selector: (row) => row.coupon_code ? row.coupon_code : 'No Coupon Code',
            sortable: true,
        },
        {
            name: "Discount Type",
            selector: (row) => row.discount_type ? row.discount_type : 'No Discount Type',
            sortable: true,
        },
        {
            name: "Discount",
            selector: (row) => row?.coupon_discount ? row?.coupon_discount : "No Discount",
            sortable: true,
        },
        {
            name: "Expiry Date",
            selector: (row) => row?.end_date ? row?.end_date : 'No Date',
            sortable: true,
        },

        {
            name: "Status",
            selector: (row) => row.is_active,
            compact: true,
            style: { paddingRight: "20px" },

            cell: (row) => {
                return (
                    <div className="user-card mt-2 mb-2" id={row.id}>
                        <Button color={row.is_active ? "success" : "danger"}
                            onClick={(e) => handleCategoryStatus(e, row.id)}
                        >
                            {row.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                        </Button>
                    </div>
                );
            },
        },

        {
            name: "Actions",
            selector: (row) => row.is_surge,
            compact: true,
            grow: 1,
            style: { paddingRight: "20px" },
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans
                        row={row}
                    />
                </div>
            ),
            sortable: false,
        },
    ];

    //action dropdown
    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={() => openEditModal(row)}>
                                <Icon name="pen" />Edit
                            </DropdownItem>
                        </li>
                        <li>
                            <DropdownItem tag="a"
                                onClick={() => openDeleteModal(row)}>
                                <Icon name="trash" />Delete
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    return (
        <React.Fragment>
            <Head title="Coupons"></Head>

            {/* content */}
            <Content>
                <BlockHead size="sm">
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle tag="h3" page>
                                Coupons
                            </BlockTitle>
                            <BlockDes className="text-soft">
                                <p>You have total {coupons?.length} coupons.</p>
                            </BlockDes>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <ToastExample
                                    show={showToast}
                                />
                                <div className="toggle-expand-content">
                                    <ul className="nk-block-tools g-3">
                                        <li className="nk-block-tools-opt">
                                            <Button color="primary" className="btn-icon"
                                                onClick={() => openAddModal()}
                                            >
                                                <Icon name="plus"></Icon>
                                            </Button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <ReactDataTable
                    data={coupons}
                    columns={tableHeadings}
                    expandableRows
                    pagination
                />
            </Content>

            {/* add and edit modal */}
            <Modal
                isOpen={modal.add || modal.edit}
                toggle={() => setModal({ add: false })}
                className="modal-dialog-centered"
                size="lg"
            >
                <ModalBody>
                    <a href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                        }}
                        className="close"  >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2">
                        <h5 className="title">{modal.edit ? "Editing Coupon - " + editingCoupon?.name : "Add Coupon"}</h5>
                        <div className="mt-4">
                            <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)} encType="multipart/formData">
                                <Col md="12">
                                    <FormGroup>
                                        <label className="form-label">Coupon Name</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="name"
                                            placeholder="Enter Coupon Name"
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.name && <span className="invalid">{errors.name.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Slider Image </label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            name="image"
                                            onChange={(e) => {
                                                setImage(e.target.files[0])
                                            }}
                                        />
                                        {errors.image && <span className="invalid">{errors.image.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Single Coupon Image </label>
                                        <input
                                            className="form-control"
                                            type="file"
                                            name="image2"
                                            onChange={(e) => {
                                                setImage2(e.target.files[0])
                                            }}
                                        />
                                        {errors.image && <span className="invalid">{errors.image.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                    <FormGroup>
                                        <label className="form-label">Current Slider Image </label>
                                        <div className="" id={editingCoupon.id}>
                                            {editingCoupon?.image ?
                                                <img src={WEBSITE_BASE_URL + editingCoupon?.image} alt="brand" style={{ width: '8rem', borderRadius: '5px' }} />
                                                :
                                                <>
                                                    <img src={noimage} alt="brand" style={{ height: '7vh', width: '7vh' }} />
                                                    <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                </>
                                            }
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="6" style={modal.edit ? { display: 'block' } : { display: 'none' }}>
                                    <FormGroup>
                                        <label className="form-label">Current Single Coupon Image </label>
                                        <div className="" id={editingCoupon.id}>
                                            {editingCoupon?.image2 ?
                                                <img src={WEBSITE_BASE_URL + editingCoupon?.image2} alt="brand" style={{ width: '8rem', borderRadius: '5px' }} />
                                                :
                                                <>
                                                    <img src={noimage} alt="brand" style={{ height: '7vh', width: '7vh' }} />
                                                    <span className='m-1' style={{ color: '#330033', fontSize: '9px' }}>No image found</span>
                                                </>
                                            }
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <label className="form-label">Description</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="description"
                                            placeholder="Enter Description"
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.description && <span className="invalid">{errors.description.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Latitude </label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="latitude"
                                            placeholder="Enter City Latitude"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                        />
                                        {errors.latitude && <span className="invalid">{errors.latitude.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Longitude</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="longitude"
                                            placeholder="Enter City Longitude"
                                            ref={register({ required: "This field is required" })}
                                        />
                                        {errors.longitude && <span className="invalid">{errors.longitude.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Start Date</label>
                                        <input
                                            className="form-control"
                                            type="date"
                                            name="start_date"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                        />
                                        {errors.start_date && <span className="invalid">Start Date is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">End Date</label>
                                        <input
                                            className="form-control"
                                            type="date"
                                            name="end_date"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                        />
                                        {errors.end_date && <span className="invalid">End Date is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Radius</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="radius"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter city maximum delivery radius"
                                        />
                                        {errors.radius && <span className="invalid">{errors.radius.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Discount Type</label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="discount_type"
                                                control={control}
                                                render={({ onChange, value, ref }) => (
                                                    <RSelect
                                                        options={discount_type}
                                                        placeholder="Select Discount Type"
                                                        onChange={(val) => onChange(val.value)}
                                                        defaultValue={discount_type.find((type) => type.value === value)}
                                                    />
                                                )}
                                                ref={register({ required: "This field is required" })}
                                            />
                                            {errors.discount_type && (
                                                <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Discount Type</span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Coupon Code</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="coupon_code"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter Coupon Code"
                                        />
                                        {errors.coupon_code && <span className="invalid">Code is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Coupon Discount</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="coupon_discount"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter Coupon Discount"
                                        />
                                        {errors.coupon_discount && <span className="invalid">Coupon Discount is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Maximum Discount</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="max_discount"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter Maximum Discount"
                                        />
                                        {errors.max_discount && <span className="invalid">Maximum Discount is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Max No of use in Total</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="max_count"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter coupon Max Count"
                                        />
                                        {errors.max_count && <span className="invalid">Max Count is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Min Sub Total</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="min_sub_total"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter your Coupon Min sub total"
                                        />
                                        {errors.min_sub_total && <span className="invalid">Min Sub is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Sub Total Not Reached Message</label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="sub_total_message"
                                            ref={register({
                                                required: "This field is required",
                                            })}
                                            placeholder="Enter coupon sub total not reached message"
                                        />
                                        {errors.sub_total_message && <span className="invalid">Sub Total Message is a required field</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">User Type</label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="user_type"
                                                control={control}
                                                render={({ onChange, value, ref }) => (
                                                    <RSelect
                                                        options={user_types}
                                                        onChange={(val) => onChange(val.value)}
                                                        placeholder="Select User Type"
                                                        
                                                        defaultValue={user_types.find((city) => city.value === value)}
                                                    />
                                                )}
                                                ref={register({ required: "This field is required" })}
                                            />
                                            {errors.user_type && (
                                                <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a User Type</span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">City</label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="city_id"
                                                control={control}
                                                render={({ onChange, value, ref }) => (
                                                    <RSelect
                                                        options={listCities}
                                                        onChange={(val) => {
                                                            onChange(val.value)
                                                            setCityId(val.value)
                                                            setWarehouseId(null)
                                                            setWarehouseIds([])
                                                            setItemIds([])
                                                        }}
                                                        placeholder="Select City"
                                                        defaultValue={listCities.find((city) => city.value === cityId)}
                                                    />
                                                )}
                                                ref={register({ required: "This field is required" })}
                                            />
                                            {errors.city_id && (
                                                <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a City</span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Coupon Type</label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="coupon_type"
                                                control={control}
                                                render={({ onChange, value, ref }) => (
                                                    <RSelect
                                                        options={coupon_types}
                                                        onChange={(val) => {
                                                            onChange(val.value)
                                                            setCouponType(val.value)
                                                        }}
                                                        placeholder="Select Coupon Type"
                                                        defaultValue={coupon_types.find((type) => type.value === couponType)}
                                                    />
                                                )}
                                            />
                                            {errors.coupon_type && (
                                                <span className="invalid" style={{ color: '#e85347', fontSize: '11px', fontStyle: 'italic' }}>Please choose a Coupon Type</span>
                                            )}
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="12" style={couponType == "MULTI_WAREHOUSE" || couponType == "SINGLE_WAREHOUSE" ? { display: 'block' } : { display: 'none' }}>
                                    <FormGroup>
                                        <label className="form-label">Slider Applicable Warehouse :</label>
                                        {couponType == "MULTI_WAREHOUSE" ? (
                                            <div className="form-control-wrap">
                                                <Controller
                                                    name="warehouse_ids"
                                                    control={control}
                                                    render={({ onChange, value }) => (
                                                        <RSelect
                                                            options={AllWarehouse}
                                                            isMulti
                                                            onChange={(val) => {
                                                                const selectedIds = val.map(option => option.value);
                                                                setWarehouseIds(selectedIds);
                                                                onChange(selectedIds);
                                                            }}
                                                            placeholder="Select Warehouse"
                                                            value={AllWarehouse.filter(warehouse => warehouseIds?.includes(warehouse?.value))}
                                                            defaultValue={AllWarehouse.filter(warehouse => warehouseIds?.includes(warehouse?.value))}
                                                        ></RSelect>
                                                    )}
                                                />
                                            </div>
                                        ) : couponType == "SINGLE_WAREHOUSE" ? (
                                            <div className="form-control-wrap">
                                                <Controller
                                                    name="warehouse_id"
                                                    control={control}
                                                    render={({ onChange, value }) => (
                                                        <RSelect
                                                            options={AllWarehouse}
                                                            onChange={(val) => {
                                                                onChange(val.value)
                                                                setWarehouseId(val.value)
                                                            }}
                                                            placeholder="Select Warehouse"
                                                            value={AllWarehouse.filter(warehouse => warehouse?.value === warehouseId)}
                                                            defaultValue={AllWarehouse.filter(warehouse => warehouse?.value === warehouseId)}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        ) : ""}
                                    </FormGroup>
                                </Col>
                                <Col md="12" style={couponType == "ITEM" ? { display: 'block' } : { display: 'none' }}>
                                    <FormGroup>
                                        <label className="form-label">Slider Applicable Item :</label>
                                        <div className="form-control-wrap">
                                            <Controller
                                                name="item_ids"
                                                control={control}
                                                render={({ onChange, value }) => (
                                                    <RSelect
                                                        options={AllItems}
                                                        isMulti
                                                        onChange={(val) => {
                                                            const selectedIds = val.map(option => option.value);
                                                            setItemIds(selectedIds);
                                                            onChange(selectedIds);
                                                        }}
                                                        placeholder="Select Item"
                                                        value={AllItems?.filter(item => itemIds?.includes(item?.value))}
                                                        defaultValue={AllItems?.filter(item => itemIds?.includes(item?.value))}
                                                    ></RSelect>
                                                )}
                                            />
                                        </div>

                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup >
                                        <div className="custom-control-sm custom-switch">
                                            <input type="radio" className="custom-control-input" id="popular" checked={popular} onClick={() => setPopular(!popular)} />
                                            <label className="custom-control-label user-select-none" htmlFor="popular">Is Popular </label>
                                        </div>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button type="submit" color="primary" size="lg" className="btn-block">
                                                {form_loading ? (
                                                    <>
                                                        <Spinner size="sm" color="light" /> {modal.edit ? "Updating Coupon" : "Creating New Coupon"}
                                                    </>
                                                ) : (
                                                    <React.Fragment>{modal.edit ? "Update Coupon" : "Add New Coupon"}</React.Fragment>
                                                )}
                                            </Button>
                                        </li>
                                        <li>
                                            <a href="#cancel" onClick={(ev) => {
                                                ev.preventDefault();
                                                onFormCancel();
                                            }}
                                                className="link link-light"   >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </Col>
                            </Form>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            {/* delete modal */}
            <Modal
                isOpen={modal.delete}
                toggle={() => setModal({ delete: false })}
                className="modal-dialog-centered"
            // size="lg"
            >
                <ModalBody className='pt-3 pb-2'>
                    <a
                        href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                        }}
                        className="close"
                    >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2">
                        <h5 className="title">Delete Coupon{' '}
                            <Badge color="primary">
                                {deletingCoupon?.name}
                            </Badge>
                            {' '}
                            ?
                        </h5>
                        <div className='mt-2'>
                            <span>This Item category will be deleted. Do you really want to delete this category ?</span>
                        </div>
                        <div className="mt-3">
                            <ul className="align-center flex-wrap flex-sm-nowrap gx-4">
                                <li>
                                    <Button onClick={(e) => {
                                        e.preventDefault();
                                        onFormSubmit();
                                    }} color="danger" className="px-4 btn-block">
                                        {form_loading ? (
                                            <>
                                                <Spinner size="sm" color="light" />Deleting
                                            </>
                                        ) : (
                                            <React.Fragment>Delete</React.Fragment>
                                        )}
                                    </Button>
                                </li>
                                <li>
                                    <a
                                        href="#cancel"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            onFormCancel();
                                        }}
                                        className="link link-light"
                                    >
                                        Cancel
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default Coupons
